const GET_USERS_PENDING: string = 'GET_USERS_PENDING'
const GET_USERS_SUCCESS: string = 'GET_USERS_SUCCESS'
const GET_USERS_ERROR: string = 'GET_USERS_ERROR'
const GET_USERS_INIT: string = 'GET_USERS_INIT'

export { GET_USERS_PENDING, GET_USERS_SUCCESS, GET_USERS_ERROR, GET_USERS_INIT }
